module.exports = __webpack_public_path__ + "media/src/img/footer-deco-rh-64ac83a75f3b77534f5f1c6af2c4a1ea.svg";